import React from 'react'
import { List, Datagrid, TextField, Filter, TextInput, EditButton, DeleteButton, ReferenceField } from 'react-admin'

const TagFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Search" source="q" alwaysOn />
  </Filter>
)

const TagList = (props) => (
  <List hasCreate filters={<TagFilter />} {...props}>
    <Datagrid rowClick="edit">
      <TextField source="id" />
      <ReferenceField source="tagTypeId" reference="tag-types" label="Tag Type">
        <TextField source="name" />
      </ReferenceField>
      <TextField source="name" />
      <TextField source="description" />
      <EditButton />
      <DeleteButton />
    </Datagrid>
  </List>
)

export default TagList

